module.exports = __webpack_public_path__ + "static/img/77.6cc41fe2.svg";